"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9875,8491],{

/***/ 9875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47322);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





function BodyText(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      id = _ref.id,
      className = _ref.className,
      styles = _ref.styles,
      whiteText = _ref.whiteText;

  if (!children) {
    return null;
  }

  className = className ? "ob-bodyText ".concat(className) : 'ob-bodyText';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Suspense, {
    fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_1__["default"], {}),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Tag, {
      id: id,
      className: className,
      "data-white-text": whiteText,
      style: styles,
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(children)
      }
    })
  });
}

BodyText.defaultProps = {
  tag: 'p',
  className: '',
  styles: {},
  whiteText: false
};
/* harmony default export */ __webpack_exports__["default"] = (BodyText);

/***/ })

}]);